<quill-editor [formControl]="ctx.control" [modules]="modules" [scrollingContainer]="scrollingContainerNode">
</quill-editor>
